import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import { useUserStore } from '@store/user';

export function useAffiliates() {
    const userStore = useUserStore();
    const isTenantReady = computed(() => Boolean(userStore.tenantId));
    const {
        data: affiliates,
        isLoading,
        isFetching,
        refetch,
        error,
    } = useQuery({
        queryKey: ['affiliates', userStore.tenantId],
        queryFn: retrieveAffiliates,
        retry: false,
        // Keep previous data only when a tenant is present so we don't flash data for a different tenant
        keepPreviousData: isTenantReady,
        // Always treat as stale so navigation into the form forces a fresh fetch
        staleTime: 0,
        // Only run when tenantId is available to avoid null tenant header fetches
        enabled: isTenantReady,
        refetchOnMount: 'always',
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
    });

    async function retrieveAffiliates() {
        const {
            data: { data: response },
        } = await window.tenantAxios.get('affiliates');
        return response;
    }

    const affiliatesWithAll = computed(() => {
        if (!affiliates.value || affiliates.value?.length == 0) return [];
        return [{ id: 'ALL', name: 'All' }, ...affiliates.value];
    });

    return {
        affiliates,
        affiliatesWithAll,
        isLoading,
        isFetching,
        refetch,
        error,
    };
}
